export const LoadingTypes = {
  Idle: 'idle',
  Pending: 'pending',
  Succeeded: 'succeeded',
  Failed: 'failed',
} as const

type LoadingType = (typeof LoadingTypes)[keyof typeof LoadingTypes]

export type CommonState = {
  loading: LoadingType
  error: string
}
